import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Layout/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="row">
            {/* About Column - Add text-start class */}
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 text-start">
              <div className="footer-widget">
                <div className="footer-logo">
                  
                    <div className="logo-text">
                <img 
              src="images/logo3.png" 
              alt="Pentagram Infotech" 
                
            />
              </div>
                </div>
                <p className="footer-about">
                  Leading IT solutions provider offering comprehensive services including cloud computing, 
                  cybersecurity, software solutions, and IT support.
                </p>
                <div className="social-links">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <i className="bi bi-linkedin"></i>
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <i className="bi bi-instagram"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Our Services Column - Add text-start class */}
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 text-start">
              <div className="footer-widget">
                <h4 className="widget-title">Our Services</h4>
                <ul className="footer-links">
                  <li><Link to="/services">IT Services</Link></li>
                  <li><Link to="/services">Cloud Computing</Link></li>
                  <li><Link to="/services">Cyber Security</Link></li>
                  <li><Link to="/services">IT Support</Link></li>
                  <li><Link to="/services">IT Products</Link></li>
                  <li><Link to="/services">Software Solutions</Link></li>
                  <li><Link to="/services">Placements</Link></li>
                </ul>
              </div>
            </div>

            {/* Quick Links Column - Add text-start class */}
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 text-start">
              <div className="footer-widget">
                <h4 className="widget-title">Quick Links</h4>
                <ul className="footer-links">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/industries">Industries</Link></li>
                  <li><Link to="/services">Services</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </div>
            </div>

            {/* Contact Column - Add text-start class */}
            <div className="col-lg-3 col-md-6 text-start">
              <div className="footer-widget">
                <h4 className="widget-title">Contact Us</h4>
                <ul className="contact-info">
                  <li>
                    <i className="bi bi-geo-alt"></i>
                    <span>
                     Esares Building, 22, <br />
Koramangala 80 Feet Road, <br />
S.T. Bed, Cauvery Colony, Koramangala, <br />
Bengaluru, Karnataka 560047
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-envelope"></i>
                    <span>info@pentagraminfotechtechnologies.com</span>
                  </li>
                  {/*<li>
                    <i className="bi bi-telephone"></i>
                    <span>+91-9876543210</span>
                  </li>*/}
                  <li>
                    <i className="bi bi-clock"></i>
                    <span>Mon - Fri: 9:00 AM - 6:00 PM</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright - Update with responsive classes */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-start">
              <p className="copyright">
                &copy; {currentYear} Pentagram Infotech Private Limited. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-start text-md-end">
              <div className="footer-bottom-links">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/terms">Terms of Service</Link>
                <Link to="/sitemap">Sitemap</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;